import type z from 'zod/v4'
import { relations } from 'drizzle-orm'
import { index, integer, jsonb, pgTable, text, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { Lesson } from './lesson'

export const LessonQuestion = pgTable(
  'lesson_question',
  {
    id: uuid().notNull().primaryKey(),
    lessonId: uuid()
      .notNull()
      .references(() => Lesson.id, { onDelete: 'cascade' }),
    question: text().notNull(),
    imageKey: text(), // private-media filename key (was imageUrl / public-media)
    description: text(),
    correctFeedback: text(),
    incorrectFeedback: text(),
    options: jsonb('options').notNull(), // { text?: string; imageKey?: string }[]
    correctAnswerIndex: integer().notNull(),
    order: integer().notNull(),
  },
  (table) => [
    index('lesson_question_lesson_idx').on(table.lessonId),
    index('lesson_question_order_idx').on(table.lessonId, table.order),
  ],
)

export const lessonQuestionRelations = relations(LessonQuestion, ({ one }) => ({
  lesson: one(Lesson, {
    fields: [LessonQuestion.lessonId],
    references: [Lesson.id],
  }),
}))

export const InsertLessonQuestionSchema = createInsertSchema(LessonQuestion)
export const UpdateLessonQuestionSchema = createUpdateSchema(LessonQuestion).omit({ id: true }).partial()
export const SelectLessonQuestionSchema = createSelectSchema(LessonQuestion)

export type InsertLessonQuestion = typeof LessonQuestion.$inferInsert
export type UpdateLessonQuestion = z.infer<typeof UpdateLessonQuestionSchema>
export type SelectLessonQuestion = typeof LessonQuestion.$inferSelect
